import { Box } from "@mui/material";

/**
 * Faixa fixa no canto da tela só no build de homologação (develop.env define
 * REACT_APP_ENV=develop; main.env não), pra ninguém confundir o ambiente sem
 * olhar o link. Não intercepta cliques.
 */
const FaixaAmbiente = () => {
  if (process.env.REACT_APP_ENV !== "develop") return null;

  return (
    <Box
      aria-hidden
      sx={{
        position: "fixed",
        top: 28,
        left: -56,
        width: 220,
        py: 0.5,
        transform: "rotate(-45deg)",
        bgcolor: "#f57c00",
        color: "#fff",
        textAlign: "center",
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: "0.08em",
        boxShadow: 3,
        opacity: 0.92,
        zIndex: (theme) => theme.zIndex.tooltip + 1,
        pointerEvents: "none",
        userSelect: "none",
      }}
    >
      HOMOLOGAÇÃO
    </Box>
  );
};

export default FaixaAmbiente;
